module.exports = __webpack_public_path__ + "assets/img/title-43316815.png";